import { memo, useCallback } from 'react';

import { IconArrowUp02 } from '@wconcept/wconcept-ui-renewal/components/atoms/svg';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import Tag from '@wconcept/wconcept-ui-renewal/components/atoms/Tag';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';

import * as S from './style';

interface IProps {
  type?: 'common' | 'brand' | string;
  keyword?: string;
  name?: string;
  nameEn?: string;
  exclusive?: boolean;
  onClick?: () => void;
}

const SearchAutoItem = ({
  type = 'common',
  keyword = '',
  name = '',
  nameEn = '',
  exclusive,
  onClick,
}: IProps) => {
  const className = classNameBind(['keyword-item item']);

  return (
    <S.SearchAutoItem className={className}>
      <Button
        onClick={e => {
          e.preventDefault();
          onClick?.();
        }}
      >
        {type === 'brand' ? (
          <>
            <Text color="#9d9d9d" ellipsis={1}>
              <Text size={14} color="#000" className="name">
                {name}
              </Text>
              <Text size={12} className="name-en">
                {nameEn}
              </Text>
            </Text>
            <Tag>브랜드</Tag>
            {exclusive === true && <Tag className="tag-exclusive">단독</Tag>}
            <IconArrowUp02 />
          </>
        ) : (
          <Text size={14} ellipsis={1} className="name">
            {name}
          </Text>
        )}
      </Button>
    </S.SearchAutoItem>
  );
};

export default memo(SearchAutoItem);
